@if (displayQmAdItem && pathName() === 'home' && !adBlocker()) {
  <div @hptoAnimation class="mx-auto pb-3 qm-w-fit-content qm-w-max-1100px homepage-take-over-container">
    @if (displayQmAdItem.FileType === 1) {
      <a href="{{ displayQmAdItem.TargetUrl }}" class="d-block ad-wrapper" target="_blank" (click)="trackHPTOClick()">
        <img src="{{ displayQmAdItem.FileLocation }}" alt="advertisement" />
      </a>
    }
    @if (displayQmAdItem.FileType === 3) {
      <a
        href="{{ displayQmAdItem.TargetUrl }}"
        class="d-block ad-wrapper"
        target="_blank"
        [innerHtml]="displayQmAdItem.Description | safeHtml"
        (click)="trackHPTOClick()"></a>
    }
    <!-- <mat-checkbox (change)="blockQmAdItem(displayQmAdItem.Id)" class="align-text-top">Do not show again</mat-checkbox> -->
    <div class="mt-1">
      <input
        type="checkbox"
        (change)="trackHPTOClose(); blockQmAdItem(displayQmAdItem.Id)"
        class="qm-cursor-clickable ms-2"
        id="notShowAgain" />
      <label for="notShowAgain" class="ms-1 qm-cursor-clickable">Do not show again</label>
      <button mat-icon-button class="float-end" (click)="trackHPTOClose(); displayQmAdItem = null">
        <span class="material-icons" aria-label="close">clear</span>
      </button>
    </div>
  </div>
}
